var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFontgroesse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fontgroesse__Icn/40px/Fontgroesse",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fontgroesse__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Fontgroesse__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fontgroesse__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Fontgroesse__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.5200893,27 L10.5200893,26.5998558 C10.0811012,26.5782264 9.76674107,26.4935112 9.57700893,26.3457102 C9.38727679,26.1979092 9.29241071,26.037491 9.29241071,25.8644557 C9.29241071,25.6986301 9.3296131,25.5328046 9.40401786,25.3669791 C9.50074405,25.1506849 9.65327381,24.9091565 9.86160714,24.6423937 L9.86160714,24.6423937 L10.9330357,23.3987022 L11.8705357,22.2739726 L16.5580357,22.2739726 L16.4575893,24.1449171 C16.4203869,24.9379957 16.3162202,25.4949531 16.1450893,25.8157895 C15.9739583,26.1366258 15.7842262,26.3475126 15.5758929,26.4484499 C15.4791667,26.4917087 15.1071429,26.5421774 14.4598214,26.5998558 L14.4598214,26.5998558 L14.3370536,27 L20.8883929,27 L21,26.5998558 C20.5238095,26.5638068 20.1834077,26.4340303 19.9787946,26.2105263 C19.7741815,25.9870224 19.671875,25.630137 19.671875,25.1398702 C19.671875,25.0100937 19.6830357,24.6315789 19.7053571,24.0043259 L19.7053571,24.0043259 L20.2075893,12 L19.7053571,12 L8.97991071,24.4044701 C8.19866071,25.3056957 7.59970238,25.9005047 7.18303571,26.1888969 C6.87053571,26.3979813 6.51339286,26.5349676 6.11160714,26.5998558 L6.11160714,26.5998558 L6,27 L10.5200893,27 Z M16.5580357,21.3871665 L12.640625,21.3871665 L16.8482143,16.6070656 L16.5580357,21.3871665 Z M27.9936309,10.6757377 L32.2362716,14.9183784 L31.1338921,15.9005497 L28.9999105,13.7667377 L28.9999105,25.1887377 L31.1338921,23.055936 L32.2362716,24.0381073 L27.9936309,28.280748 L23.7729105,24.0600276 L24.8307422,23.0021959 L26.9999105,25.1717377 L26.9999105,13.7837377 L24.8307422,15.9542898 L23.7729105,14.8964581 L27.9936309,10.6757377 Z",
    id: ".._.._src_svg_Icn_40px_Fontgroesse__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontgroesse);
export default __webpack_public_path__ + "static/media/Fontgroesse.c55cfc1839c96d7db85ba8244158ded1.svg";
export { ForwardRef as ReactComponent };